export default "__VITE_ASSET__Dn$sTs1$__"